
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"60","viewBox":"0 0 70 85"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"transform":"translate(2 2)","filter":"url(#oeamtc-floating__dropshadow)","fill":"var(--color-accent-primary)","d":"M29.5 68.263a3.37 3.37 0 110 6.737 3.37 3.37 0 110-6.737zM29.5 0C45.792 0 59 13.44 59 30.017c0 12.482-7.487 23.184-18.14 27.71-9.09 4.616-10.225 8.852-11.36 8.852-1.135 0-2.27-4.236-11.278-8.817C7.525 53.255 0 42.53 0 30.017 0 13.439 13.208 0 29.5 0z"}}),_c('circle',{attrs:{"cx":"32","cy":"32","r":"10","fill":"transparent","stroke":"#000","stroke-width":"3"}})])
          )
        }
      }
    